import React from "react";
import i18next from "../../assets/i18n/i18n";

export default class AccountStatusOkLogo extends React.Component {
    render(): React.ReactElement {
        return (
            <svg
                width="62"
                height="62"
                viewBox="0 0 62 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`account-status-logo-${i18next.language}`}
            >
                <g clipPath="url(#clip0)">
                    <path
                        d="M3.31747 44.4383C0.705868 41.8267 -0.649501 36.771 0.305923 33.204L5.52059 13.7451C6.47601 10.1781 10.1781 6.47604 13.7451 5.52062L33.204 0.305954C36.771 -0.64947 41.8267 0.705899 44.4383 3.3175L58.6825 17.5617C61.2941 20.1682 62.6478 25.229 61.7009 28.796L56.4794 48.2549C55.524 51.8219 51.8219 55.524 48.2549 56.4794L28.796 61.7009C25.229 62.6563 20.1733 61.3027 17.5617 58.6911L3.31747 44.4383Z"
                        fill="#FF4612"
                    />
                    <path
                        d="M24.8398 44.4062C25.582 45.1484 26.8438 45.1484 27.5859 44.4062L49.4062 22.5859C50.1484 21.8438 50.1484 20.582 49.4062 19.8398L46.7344 17.168C45.9922 16.4258 44.8047 16.4258 44.0625 17.168L26.25 34.9805L17.8633 26.668C17.1211 25.9258 15.9336 25.9258 15.1914 26.668L12.5195 29.3398C11.7773 30.082 11.7773 31.3438 12.5195 32.0859L24.8398 44.4062Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="62" height="62" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
